function ReviewOverviewDirective() {
    return {
        controller: 'ReviewController',
        controllerAs: 'vm',
        restrict: 'E',
        template: require('./review-overview-template.html'),
        scope: {
            viewMode: '@',
            department: '='
        },
        transclude: true,
        link(scope) {

            scope.isViewAll = () => {
                return scope.viewMode === 'all';
            };

            scope.isPreview = () => {
                return scope.viewMode === 'preview';
            };

            scope.canShowBackLink = () => {
                return scope.isViewAll() && scope.vm.category.length > 0;
            };

            scope.sortByChange = (option) => {
                scope.vm.getReviewsBy(option.id);
            };
        }
    };
}

module.exports = ReviewOverviewDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/review-overview-directive.js
 **/